module.exports = __webpack_public_path__ + "img/sea_urchin.6a719052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sea_urchin.jpg
// module id = AOp+
// module chunks = 0